import { postReq } from '../../api';

export const enrollCourse = (data, cb) => postReq('/webapi/student/course-enrollment/enroll', data, '', cb);
